import {
  LabelAndImage,
  LabelAndValue,
  SkymilesAndValue,
  UserNameAndValue
} from '../models/ui.interfaces';

export type TrustType =
  | 'html'
  | 'style'
  | 'script'
  | 'url'
  | 'resourceUrl'
  | 'svg';

export type ApplicationType = 'award' | 'enrollment' | 'revenue';
export type BorderType = 'none' | 'border-top' | 'border-bottom';

export type CardStatus = 'approved' | 'pending' | 'notApproved';
export type ColorThemeType = HeaderColorType;
export type ComparatorValueType = number | string | boolean;
export type ContentAlignType = 'left' | 'center' | 'right';
export type DeviceType = 'desktop' | 'tablet' | 'mobile';
export type GridItemId = string | number;
export type FontStyleType = 'normal' | 'italic' | 'oblique';
export type HeaderColorType = 'dark' | 'light' | 'red';
export type HeightType = 'full' | 'auto';
export type WidthType = 'small' | 'normal' | 'auto';
export type IconType = 'cancel' | 'info' | 'expand';
export type LabelRoleSize =
  | 'small'
  | 'medium'
  | 'large'
  | 'large-bold'
  | 'extra-large'
  | 'double-extra-large'
  | 'normal'
  | 'medium-bold'
  | 'extra-large-bold'
  | '';
export type LabelRoleType = 'title' | 'info' | 'action' | 'selected' | 'medium';
export type LinkType = 'primary' | 'secondary' | 'muted' | 'danger' | 'caret';
export type LinkTarget = '_blank' | '_parent' | '_self' | '_top';
export type PositionType =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom-left'
  | 'center';
export type PositionTopOrBottom = 'bottom' | 'top';
export type ProfileType = 'business' | 'personal';
export type ServicesType = 'allowances' | 'charges' | 'productCatalog';
export type SelectionState = 'deselect' | 'select';
export type SortDirection = 'ascending' | 'descending';
export type StackType = 'fresh-air' | 'bau';
export type TextAlignType = 'sup' | 'sub' | 'baseline';
export type TextType = string | 'link';
export type ValueType = 'positive' | 'negative' | '+' | '-';
export type SizeType = 'small' | 'normal' | 'medium' | 'large';
export type ElementVerticalAlignType = 'start' | 'middle' | 'end';
export type FlexAlignment = 'flex-start' | 'center' | 'flex-end';
export type SortReturnType = -1 | 0 | 1;
export type CaretType = 'primary' | 'secondary' | 'tertiary' | 'solid';
export type AccordionType = CaretType;
export type FontIconType = 'primary' | 'secondary' | 'info';
export type PageHeaderType = 'primary' | 'secondary' | 'tertiary';
export type OriginDestinationType = 'primary' | 'secondary' | 'tertiary';
export type HeaderCopyTextType = 'primary' | 'secondary';
export type SanitizeType =
  | 'none'
  | 'html'
  | 'style'
  | 'script'
  | 'url'
  | 'resourceUrl';

export type SimplePriceInfoSize = 'small' | 'base' | 'large';
export type ImageWithLabelSize = 'small' | 'base' | 'large';
export type ImageSize = 'small' | 'base' | 'large';

export type CardType = 'tile-card-vertical' | 'tile-card-horizontal';

export type PNRQueryParamType = string | boolean;
export type RefundLineCell =
  | LabelAndValue
  | LabelAndImage
  | string
  | UserNameAndValue
  | SkymilesAndValue;

export type RefundLineRow = Readonly<
  [RefundLineCell, RefundLineCell, RefundLineCell, RefundLineCell]
>;

export type ActionType = 'text' | 'caret' | 'notify' | 'button';
export type GenericContentType = 'primary' | 'secondary' | '';
